<template>
  <div class="table-container" ref="tableContainer">
    <!--header-row-class-name="test"-->
    <!--border-->
    <!--@header-dragend="testmrthod"-->
    <el-table class="egrid"
              :data="data" ref="eltable"
              header-row-class-name="wms-table-header"
              v-loading="loading"
              v-bind="tableBind"
              v-on="$listeners">
      <template v-for="tp in typesColumns">
        <el-table-tree-column v-if="tp.type === 'tree'"
                              :fixed='tp.fixed'
                              v-bind="tp.props"
                              align="center" header-align="center"
        >
          <!--:remote="remote"-->
        </el-table-tree-column>
        <el-table-column
          v-else-if="tp.type === 'expand'"
          v-bind="tp.props"
          type="expand"
          :fixed='tp.fixed'
          align="center" header-align="center"
        >
          <template slot-scope="props">
            <slot name="expand" v-bind="props"></slot>
          </template>
        </el-table-column>
        <el-table-column v-else-if="tp.type === 'index'" :render-header="renderHeader"
                         :fixed='tp.fixed'
                         v-bind="tp.props"
                         align="center" header-align="center">
          <template slot-scope="scope">
            {{pageSize * ( pageNow - 1 ) + Number(scope.$index) + 1}}
          </template>
        </el-table-column>
        <el-table-column v-else-if="tp.type === 'selection'"
                         :type="tp.type"
                         :fixed='tp.fixed'
                         v-bind="tp.props"
                         align="center" header-align="center">
        </el-table-column>
      </template>
      <el-table-column v-for="col in showColumns"
                       :key="col.label" v-bind="getColBind(col)"
                       align="center" header-align="center">
        <template slot-scope="scope">
          <component :is="col.component"
                     v-bind="getCptBind(scope, col)"
                     v-on="col.listeners">
          </component>
        </template>
      </el-table-column>
      <template v-if="slotAppend" slot="append">
        <slot name="append"></slot>
      </template>
    </el-table>
    <!--'scroll-hasY': isTableHasY ,-->
    <div class="scroll" v-bind:class="{'scroll-fixed':isScrollFixed}"
         v-bind:style="{ width: scrollContainerWidth }"
         ref="scrollElement"
         v-if="showScroll"
         @scroll="scrollBarMove($event)">
      <div v-bind:style="{ height: '1px', width: scrollbodyWidth }" ref="scrollbars"></div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import ElementUI from 'element-ui';
  import 'element-ui/lib/theme-chalk/index.css';
  import ElTable from 'element-ui/lib/table';
  import ElTableColumn from 'element-ui/lib/table-column';
  import ElTreeGrid from 'element-tree-grid';
  import throttle from 'throttle-debounce/throttle';
  import scrollbarWidth from './scrollbar-width';
  import elementMethods from './elementMethods';
  import common from './common';
  import Text from './text';

  Vue.use(ElementUI);

  const BOOLEAN_KEYS = [
    'fit',
    'stripe',
    'border',
    'show-header',
    'highlight-current-row',
    'default-expand-all',
    'show-summary'
  ];
  // element table 表格默认配置项
  const DEFAULT_BOOLEAN_KEYS = {
    'highlight-current-row': ''
  };

  const COLUMN_PROPS = {
    align: 'left',
    component: Text
  };

  const TYPES = ['tree', 'selection', 'expand', 'index'];

  const TYPE_COLUMN_OPTION = {
    selection: {
      width: 55,
      reserveSelection: false
    },
    expand: {
      width: 48
    },
    index: {
      width: 80
    },
    tree: {
      expandAll: false,
      treeKey: 'id',
      childNumKey: 'child_num',
      parentKey: 'parent_id',
      width: 48
    }
  };

  const COLUMN_KEY_MAP = {
    label: 'label',
    prop: 'prop'
  };

  export default {
    name: 'Egrid',
    mixins: [elementMethods],
    props: {
      container: {
        // default: window
        default: function () {
          return window;
        }
      },
      data: {
        type: Array,
        default: []
      },
      judgeScorll: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      pageNow: { // 当前页码 控制序号
        type: Number,
        default: 1
      },
      pageSize: { // 当前页数据最多展示数量 控制序号
        type: Number,
        default: 20
      },
      columns: {
        type: Array,
        default: []
      },
      // columnType: [String, Array],
      columnType: Array,
      // 特殊列，自定义配置
      columnTypeProps: Object,
      columnKeyMap: Object,
      columnsProps: Object,
      columnsSchema: Object,
      columnsHandler: Function,
      slotAppend: Boolean
    },
    components: {
      [ElTable.name]: ElTable,
      [ElTreeGrid.name]: ElTreeGrid,
      [ElTableColumn.name]: ElTableColumn
    },
    data() {
      // 设置初始选择值
      let _filteredColumn = this.columns.map(item => item.prop);
      // key值转换
      const map = Object.assign({}, COLUMN_KEY_MAP, this.columnKeyMap);
      let _column = this.columns.map(item => {
        return {
          label: item[map.label],
          prop: item[map.prop]
        };
      });
      return {
        // rowKey: undefined, // 标识列
        scrollContent: undefined,
        showColumns: [], // 实际每列的配置
        typesColumns: [], // 特殊功能列配置
        exploreSize: {}, // 视窗大小参数
        column_key_Map: map,
        columnOptions: _column,
        filteredColumn_temp: _filteredColumn,
        _escapeListenerResize: undefined, // window Resize监听
        _escapeListenerScroll: undefined, // 外层容器滚动监听
        _escapeListenerContentScroll: undefined, // table内容块滚动监听
        minColunmWidth: 80,
        isTableHasY: false, // table 是否存在纵向滚动条
        isScrollFixed: false, // 横向滚动条 是否需要更改position
        scrollbodyWidth: '0px',
        scrollContainerWidth: '0px',
        showScroll: true,
        parentVnode: this.$parent.$vnode.tag
      };
    },
    computed: {
      // 处理 $attrs 里面 Boolean 类型的 prop 和统一 prop 命名
      tableBind() {
        // let {$attrs} = this
        const $attrs = Object.assign({}, this.$attrs, DEFAULT_BOOLEAN_KEYS);
        const bind = {};
        Object.keys($attrs).forEach(key => {
          const v = $attrs[key];
          const uniformKey = key.replace(/([A-Z])/, '-$1').toLowerCase();
          bind[key] = ~BOOLEAN_KEYS.indexOf(uniformKey) && v === '' ? true : v;
        });
        if (this.columnTypeProps && Object.keys(this.columnTypeProps).includes('tree')) {
          if (Object.keys(this.columnTypeProps).includes('selection')) {
            try {
              bind.rowKey = this.columnTypeProps.tree.treeKey;
              this.columnTypeProps.selection.reserveSelection = true;
            } catch (e) {
              // console.error('---- wmsTable配置错误 ----', e);
            }
          }
        }
        return bind;
      },
      filteredColumn: {
        set(obj) {
          this.changeColumn(obj);
        },
        get() {
          return this.filteredColumn_temp;
        }
      }
    },
    methods: {
      // 列拖拽后，触发时间
      // testmrthod(width, startColumnLeft, column, event) {
      // debugger;
      // },
      remote(row, callback) {
        // let _that = this;
        if (this.columnTypeProps.tree && this.columnTypeProps.tree.remotePromise) {
          let _promise = this.columnTypeProps.tree.remotePromise;
          _promise(row).then((data) => {
            // let _options = _that.typesColumns.find(item => item.type === 'tree');
            // // console.info('_options', _options.props);
            // callback(data.filter(f => f[_options.props.parentKey] === row[_options.props.treeKey]));
            let depth = parseInt(row.depth, 10);
            let depth_child = isNaN(depth) ? 1 : depth + 1;
            let _data = data;
            _data.map(item => Object.assign(item, {depth: depth_child}));
              common.dealDataSource(_data);
            callback(_data);
            // 重新判断是否需要'悬浮'横向滚动条
            this.$nextTick(() => {
              if (this._escapeListenerScroll) {
                this.judgeScrollFixed();
              }
            });
          });
        } else {
          callback();
        }
      },
      // <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      // 创建自定义头
      renderHeader(h, {row, column, store, $index}) {
        const items = this.columnOptions.map((item, index) => {
          // return <el-option
          //   nativeOn-click={this.chooseColumn.bind(null, item.prop)}
          //   key={item.prop}
          //   label={item.label}
          //   value={item.prop}>
          // </el-option>;
          // @change="handleCheckedCitiesChange"
          // nativeOn-click={this.chooseColumn.bind(null, item.prop)}
          // on-click={this.chooseColumn.bind(null, item.prop)}
          return <el-checkbox
            on-change={this.chooseColumn.bind(undefined, item.prop)}
            key={item.prop}
            label={item.prop}>
            {item.label}
          </el-checkbox>;
        });
        // on-change={this.handleCheckedCitiesChange}
        // width="100"
        return <span class="suffix-container">
          <el-popover
            placement="bottom-end"
            visible-arrow="true"
            trigger="hover">
            <el-checkbox-group value={this.filteredColumn} on-change={this.handleCheckedCitiesChange.bind(undefined)}
                               class="table-checkbox-group">
              {items}
            </el-checkbox-group>
            <span slot="reference" style="cursor: pointer;">序号</span>
          </el-popover>
        </span>;
      },
      handleCheckedCitiesChange(event) {
        // console.log('handleCheckedCitiesChange', event);
      },
      chooseColumn(prop, value) {
        let _filteredColumn = this.filteredColumn.splice(0);
        let _index = _filteredColumn.findIndex(item => item === prop);
        if (_index > -1) {
          _filteredColumn.splice(_index, 1);
        } else {
          _filteredColumn.push(prop);
        }
        this.filteredColumn = _filteredColumn;
      },
      // 列选择事件
      changeColumn(obj) {
        this.filteredColumn_temp = obj;
        this.renderNormalColumns();
      },
      renderNormalColumns() {
        this.$nextTick(() => {
          let _tableContainer = this.$refs.tableContainer;
          if (_tableContainer) {
            const {
              columns,
              columnsHandler,
              filteredColumn_temp,
              columnsProps: props,
              columnsSchema: schema
            } = this;
            // 筛选要展示的列
            let _column = columns.filter(item => filteredColumn_temp.includes(item[this.column_key_Map.prop]));
            let renderColumns = _column.map(col => {
              const mix = schema && schema[col[this.column_key_Map.label]] || {};
              const it = Object.assign({}, COLUMN_PROPS, props, col, mix);
              it.label = it[this.column_key_Map.label];
              it.prop = it[this.column_key_Map.prop];
              it.showOverflowTooltip = true;
              return it;
            });
            let _tempColumns = columnsHandler && columnsHandler(renderColumns) || renderColumns;
            this.showColumns = this.caculateColunmsWidth(_tempColumns);
          }
        });
      },
      // 判断是否需要重新设置列宽
      needSetColumn(data) {
        return data.width === 'auto' || !data.width;
      },
      // 用于渲染特殊列
      renderTypeColumns() {
        const {columnType: type, columnTypeProps} = this;
        let typeColums = [];
        // if (typeof type === 'string' && ~TYPES.indexOf(type)) {
        //     typeColums = [type]
        // }
        if (Array.isArray(type)) {
          typeColums = type.filter(it => ~TYPES.indexOf(it));
        }
        const map = columnTypeProps || {};

        this.typesColumns = typeColums.map(type => {
          const _options = Object.assign({}, TYPE_COLUMN_OPTION[type], map[type],
            map[type] && Object.keys(map[type]).includes('remotePromise') ? {remote: this.remote} : {});
          return {
            type,
            props: _options,
            fixed: 'left'
          };
        });
      },
      getColBind(col) {
        const bind = Object.assign({}, col);
        delete bind.component;
        delete bind.listeners;
        delete bind.propsHandler;
        return bind;
      },
      getCptBind({row, column, $index}, col) {
        let index = $index;
        const props = {row, col, column, index};
        const handler = col.propsHandler;
        return handler && handler(props) || props;
      },
      // 初始和数据源变化时，重新生成列
      createColunms() {
        // 注意先后执行顺序
        this.renderTypeColumns();
        this.renderNormalColumns();
      },
      // windowResize触发事件
      resize() {
        this.getViewport();
        this.renderNormalColumns();
      },
      resizeListener() {
        window.addEventListener('resize', throttle(100, this.resize));
        // console.info(this.parentVnode + '-- table -- window Resize -- 开始监听');
        this._escapeListenerResize = () => {
          window.removeEventListener('resize', throttle(100, this.resize));
        };
      },
      // table是否需要横向滚动判断规则
      caculateColunmsWidth(_column) {
        let orderWidth = 0; // 已限定宽度
        let tableWidthMinWidth = 0;// 预测table最小宽度
        let typesColumnsWidth = 0; // 特殊列总宽度
        if (common.hasValue_arr(this.columnType)) {
          for (let key of this.columnType) {
            typesColumnsWidth += TYPE_COLUMN_OPTION[key].width;
          }
        }
        let containerWidth = this.$refs.tableContainer.clientWidth - typesColumnsWidth;
        for (let item of _column) {
          if (item.width) {
            // orderWidth += Number(item.width);
            tableWidthMinWidth += Number(item.width);
          } else {
            tableWidthMinWidth += this.minColunmWidth;
          }
        }

        if (containerWidth >= tableWidthMinWidth) {
          this.destoryScroll();
          // let count = Number((tableWidth - orderWidth - typesColumnsWidth) / 80);
          // let _columnWidth = ~~((containerWidth - orderWidth - typesColumnsWidth) / count);
          // for (let item of _column) {
          //   if (this.needSetColumn(item)) {
          //     item.width = _columnWidth + '';
          //   }
          // }
          // 新规则   限定的宽度与平均数作比较， > ? selfWidth\重新计算:averageWidth
          let length = _column.length;
          let averageWidth_temp = ~~(containerWidth / length); // temp平均宽度
          let count = 0; // 带width列计数
          for (let item of _column) {
            if (!this.needSetColumn(item) && Number(item.width) > averageWidth_temp) {
              orderWidth += Number(item.width);
              count++;
            } else {
              item.width = 'auto';
            }
          }
          let averageWidth = ~~((containerWidth - orderWidth) / (length - count));// real平均宽度
          for (let item of _column) {
            if (this.needSetColumn(item)) {
              item.width = averageWidth + '';
            }
          }
        } else {
          for (let item of _column) {
            if (this.needSetColumn(item)) {
              item.width = 80 + '';
            }
          }
          this.creartScroll(tableWidthMinWidth + typesColumnsWidth);
        }
        return _column;
      },
      // 创建横向滚动条
      creartScroll(width) {
        this.$nextTick(() => {
          if (!this.showScroll) {
            this.showScroll = true;
          }
          let _tableContainer = this.$refs.tableContainer;
          this.isTableHasY = (this.data.length + 1) * 44 > _tableContainer.clientHeight;
          this.scrollbodyWidth = this.isTableHasY ? width - scrollbarWidth() : width + 'px';
          this.scrollContainerWidth = _tableContainer.clientWidth + 'px';
          this.judgeScrollFixed();
          if (!this._escapeListenerScroll) {
            this.container.addEventListener('scroll', throttle(100, this.judgeScrollFixed));
            // console.info(this.parentVnode + '-- table -- 外层容器滚动监听 -- 开始监听');
            this._escapeListenerScroll = () => {
              this.container.removeEventListener('scroll', throttle(100, this.judgeScrollFixed));
            };
          }
        });
      },
      destoryScroll() {
        if (this.showScroll) {
          this.showScroll = false;
        }
        if (this._escapeListenerScroll) {
          this._escapeListenerScroll();
          this._escapeListenerScroll = undefined;
        }
      },
      // 联动横向滚动
      scrollBarMove(event) {
        this.$refs.eltable.$el.childNodes[2].scrollLeft = event.target.scrollLeft;
      },
      // 获取浏览器视窗大小
      getViewport() {
        // http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
        let e = window;
        let a = 'inner';
        if (!('innerWidth' in window)) {
          a = 'client';
          e = document.documentElement || document.body;
        }
        this.exploreSize = {
          width: e[a + 'Width'],
          height: e[a + 'Height']
        };
      },
      // 判断滚动条是否需要悬浮
      judgeScrollFixed() {
        this.$nextTick(() => {
          let _tableContainer = this.$refs.tableContainer;
          if (_tableContainer) {
            let pos = _tableContainer.getBoundingClientRect();
            let nowTop = this.exploreSize.height - pos.top;
            let result = nowTop < _tableContainer.clientHeight && nowTop > 44;
            if (result !== this.isScrollFixed) {
              this.isScrollFixed = result;
            }
            // // console.log('滚动条是否需要悬浮 = ', result);
          }
        });
      },
      // 判断是否滚动到底
      judgeScrollBottom() {
        if (this.scrollContent.scrollTop + this.scrollContent.clientHeight === this.scrollContent.scrollHeight) {
          this.$emit('scrollToBottom');
          // console.log('--已滚动到底部--');
        }
      }
    },
    created() {
    },
    activated() {
      this.resize();//解决被缓存的子页面在切换回来时table宽度缩水的问题
    },
    mounted() {
      this.$nextTick(() => {
        // console.log('wms-table', this);
        this.getViewport();
        this.createColunms();
        if (this.judgeScorll) {
          this.scrollContent = this.$refs.eltable.$refs.bodyWrapper;
          this.scrollContent.addEventListener('scroll', throttle(100, this.judgeScrollBottom));
          // console.info(this.parentVnode + '-- table -- table内容块滚动监听 -- 开始监听');
          this._escapeListenerContentScroll = () => {
            this.scrollContent.removeEventListener('scroll', throttle(100, this.judgeScrollBottom));
          };
        }
        this.resizeListener();
      });
    },
    beforeDestroy() {
      if (this._escapeListenerResize) {
        this._escapeListenerResize();
        // console.info(this.parentVnode + '-- table -- window Resize -- 取消监听');
      }
      if (this._escapeListenerScroll) {
        this._escapeListenerScroll();
        // console.info(this.parentVnode + '-- table -- 外层容器滚动监听 -- 取消监听');
      }
      if (this._escapeListenerContentScroll) {
        this._escapeListenerContentScroll();
        // console.info(this.parentVnode + '-- table -- table内容块滚动监听 -- 取消监听');
      }
    },
    watch: {
      columns: {
        immediate: true,
        handler: function (e) {
          this.renderNormalColumns();
          // console.log('hello world', e);
        }
      },
      data(val) {
        if (common.hasValue_arr(val)) {
            common.dealDataSource(val);
          if (this.showScroll) {
            this.renderNormalColumns();
            // this.judgeScrollFixed();
          }
          // this.createColunms();
        }
      }
    }
  };
</script>

<style lang="less">
  .el-table th, .el-table tr.wms-table-header {
    background-color: #38ADFF !important;
    font-size: 14px;
    color: white;
  }

  .scroll {
    overflow-x: auto;
    overflow-y: hidden;
    position: absolute;
    z-index: 222;
    bottom: 0;
    width: 100%;
  }

  .scroll-hasY {
    width: calc(100% - 16px);
  }

  .scroll-fixed {
    position: fixed;
  }

  .table-container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    /* max-height: 300px; */
    height: 100%;
    width: 100%;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .el-table th .suffix-container {
    line-height: initial;
    padding: 0;
    div {
      line-height: inherit;
    }
  }

  .table-checkbox-group {
    display: inline-grid;
    max-height: 200px;
    min-width: 150px;
    overflow-y: auto;
    .el-checkbox + .el-checkbox {
      margin-left: 0;
    }
  }

  .td-btn-group {
    color: #1200FF;
    a {
      color: #1200FF;
    }
    a.disabled {
      color: #B1B1B1;
      cursor: not-allowed;
    }
  }

  .tip-txt {
    display: inline-block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    color: #fff;
    border-radius: 5px;
    text-align: center;
  }

  .tip-txt + .tip-txt {
    margin-left: 5px;
  }
</style>
<!--展开子节点数据-->
<!--<el-table-column v-if="tp.type === 'expand'"-->
<!--:fixed='tp.fixed'-->
<!--:width="tp.width">-->
<!--<template slot-scope="props">-->
<!--<div class='el-table__expand-icon el-table__expand-icon&#45;&#45;expanded' v-if="props.row.hasChild"-->
<!--@click=props.store.table.toggleRowExpansion(props.row)>-->
<!--<i class='el-icon el-icon-arrow-right'></i>-->
<!--</div>-->
<!--&lt;!&ndash;<slot name="expand" v-bind="props"></slot>&ndash;&gt;-->
<!--</template>-->
<!--</el-table-column>-->
<!--align="center"-->



// WEBPACK FOOTER //
// src/main.vue